﻿import { isLoggedIn } from "./utilities";
import {getSearchParam, valueFilters} from "./overview-filter-state";

const track = (items) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(items);
	console.log(`${new Date()}: ${JSON.stringify(items)}`);
}

export const trackContactSuccess = () => {
	track({
		"event": "event-track",
		"category": "website action",
		"action": "webform submission",
		"label": "vacature_email",
	});
}

export const trackVacancyAlertSuccess = () => {
	const page = window.location.pathname.indexOf("/vacature/") === 0 ? "vdp" : "vop";
	const userState = isLoggedIn() ? "ingelogd" : "uitgelogd";

	track({
		"event": "event-track",
		"category": "website action",
		"action": "send vacancy alert",
		"label": `${page} - ${userState}`
	});
}

export const trackVacancySearch = () => {
	const term = getSearchParam(valueFilters.searchTerm);
	const location = getSearchParam(valueFilters.location);
	const radius = getSearchParam(valueFilters.radius);

	const label = location && radius ? `${location} + ${radius}km` : "-";
	const action = term ? term : "-";
	const currentSearchTrackingObject =
		{
			"event": "event-track",
			"category": "vacature zoekactie",
			"action": action,
			"label": label,
		};

	const existingSearchTracking = localStorage.getItem("vacancySearchTracking");
	const currentSearchTracking = JSON.stringify(currentSearchTrackingObject);

	if (existingSearchTracking !== currentSearchTracking && (action !== "-" || label !== "-")) {
		track(currentSearchTrackingObject);
		localStorage.setItem("vacancySearchTracking", currentSearchTracking);
	}
}


